import React from 'react'
// import { useCollection } from '../hooks/useCollection';
import { useSelector } from 'react-redux';
import { useAllTrainingDays } from '../hooks/useAllTrainingDays';
import Helper from '../util/helper';
import NamesColumns from '../components/NamesColumns';

export default function AllStatsReports({ handleChangeAppbarTitle }) {
    const allUsers = useSelector((state) => state.user.allUsers)
    const { allTrainingDays } = useAllTrainingDays()
    // const [numTdays, setNumTdays] = useState(0)

    const numTdays = allTrainingDays && allTrainingDays.flatMap((t) => t.tDays)



    var activeUsers = []
    var inactiveUsers = []
    var trainingsPerUser = []
    allTrainingDays && allTrainingDays.map(tday => {
        const user = allUsers.find(usr => usr.email.replaceAll(".", "") === tday.userId)
        if (user) {
            const tDaysStr = tday.tDays.map(t => Helper.convertToDateString(t.Date))

            const tDay = {
                userId: user.name,
                tDays: Object.values(tday.tDays),
                dates: Object.values(tDaysStr)
            }
            trainingsPerUser.push(tDay)

            const latestDate = Helper.findLatestTimestamp(tday.tDays.map(t => t.Date))
            if (Helper.isOverAMonthOld(latestDate)) {
                if (!inactiveUsers.includes(user.name)) {
                    inactiveUsers.push(user.name)
                }
            } else {
                if (!activeUsers.includes(user.name)) {
                    activeUsers.push(user.name)
                }
            }

        }
    })

    // for tday in vm.allTrainingDays {
    //     let trainingDaysByDate = timeInterval == Date.distantPast
    //         ? tday.trainingDays
    //         : tday.trainingDays.filter {Date(milliseconds: $0.date) > timeInterval}

    //     let userName = getUserName(userId: tday.userId)
    //     let lastDay = getLastTrainingDay(trainingDays: trainingDaysByDate)
    //     trainingsPerUser.append(TrainingPerUser(userId: userName, trainingCount: trainingDaysByDate.count, lastTraining: lastDay))

    //     daysPerUser.append(TrainingPerUser(userId: userName, trainingCount: getNumTrainingDays(trainingDays: trainingDaysByDate), lastTraining: lastDay))
    // }
    // trainingsPerUser.sort(using: KeyPathComparator(\.trainingCount, order: .reverse))
    // daysPerUser.sort(using: KeyPathComparator(\.trainingCount, order: .reverse))


    handleChangeAppbarTitle("Statistikk")

    return (
        <div className='user-details' >
            <div className='p-2 flex-grow-1 dig-container-bottommargin'
                style={{
                    textAlign: 'center',
                }}
            >
                <h3 style={{ color: 'GrayText', padding: 10 }}>
                    <ul>Antall brukere: {allUsers && allUsers.length}</ul>
                    <ul>Antall treninger totalt: {numTdays.length}</ul>
                </h3>
            </div>
            <div className='d-flex'>
                <div className='p-2 flex-grow-1 dig-container-leftmargin'>
                    <NamesColumns
                        header1="Aktive brukere siste måned"
                        namesArray1={activeUsers}
                        header2="Inaktive brukere"
                        namesArray2={inactiveUsers} />
                </div>
                <div className='p-2 flex-grow-1 dig-container'>
                </div>
            </div>
        </div>

    )
}
